module.exports = __webpack_public_path__ + "img/42.02d062c5.gif";